// extracted by mini-css-extract-plugin
export default {"inputLabel":"HeadlineTextField_inputLabel__MEHMu","tooltipRequired":"HeadlineTextField_tooltipRequired__Frc6w"};